module.exports = __webpack_public_path__ + "static/media/lily-carter-lose.d5464f04.jpg";